import { createContext, useState } from 'react'
import { getFeedback, saveFeeback, deleteFeeback } from '../api/feedback'
const FeedbackContext = createContext({
  data: [],
  loadData: () => {},
  saveData: () => {},
  removeData: () => {},
})
export function FeedbackContextProvider(props) {
  const [feedbacks, setFeedback] = useState([])
  const context = {
    data: feedbacks,
    loadData: async (id) => {
      let response = await getFeedback({ sup_visit_id: id })
      setFeedback(response)
      return response
    },
    saveData: async (values) => {
      let response = await saveFeeback(values)
      if (response) setFeedback((prevArray) => [...prevArray, response])
    },
    removeData: async (id) => {
      let response = await deleteFeeback(id)
      if (response) setFeedback(feedbacks.filter((item) => item.id !== id))
    },
  }
  return (
    <FeedbackContext.Provider value={context}>
      {props.children}
    </FeedbackContext.Provider>
  )
}
export default FeedbackContext
